import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a9193e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { onsubmit: "return false" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn name w25" }, "Nom"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn model w25" }, "Model"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn identifier w15" }, "N°Unique"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn registration w15" }, "Début"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn lastactivity w15" }, "Connexion"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn btns w5" })
  ])
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "tabcolumn name w25" }
const _hoisted_6 = { class: "tabcolumn model w25" }
const _hoisted_7 = { class: "tabcolumn identifier w15" }
const _hoisted_8 = { class: "tabcolumn registration w15" }
const _hoisted_9 = { class: "tabcolumn lastactivity w15" }
const _hoisted_10 = { class: "tabcolumn btns w5" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["id"]
const _hoisted_14 = { class: "tabcolumn name w15" }
const _hoisted_15 = { class: "tabcolumn model w15" }
const _hoisted_16 = { class: "tabcolumn identifier w10" }
const _hoisted_17 = { class: "tabcolumn registration w10" }
const _hoisted_18 = { class: "tabcolumn lastactivity w10" }
const _hoisted_19 = { class: "tabcolumn btns w5" }
const _hoisted_20 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _createElementVNode("div", null, [
        _createElementVNode("p", null, _toDisplayString(_ctx.UUID) + "/Appareils", 1),
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.GoBack($event)))
        }, [
          _createVNode(_component_font_awesome_icon, { icon: [ 'fas', 'arrow-left' ] })
        ])
      ]),
      _createElementVNode("form", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          onKeypress: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ResearchDevice($event))),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.researchFieldValue) = $event)),
          placeholder: "Rechercher"
        }, null, 544), [
          [_vModelText, _ctx.researchFieldValue]
        ])
      ])
    ]),
    (_ctx.apiError.length > 0)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "error",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.apiError.pop()))
        }, _toDisplayString(_ctx.apiError[_ctx.apiError.length-1]), 1))
      : _createCommentVNode("", true),
    _createElementVNode("table", null, [
      _hoisted_2,
      (_ctx.resultDevices.length > 0)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultDevices, (element) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: element.uniqid,
                id: element.uniqid
              }, [
                _createElementVNode("td", _hoisted_5, _toDisplayString(element.name), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(element.model), 1),
                _createElementVNode("td", _hoisted_7, _toDisplayString(element.identifier), 1),
                _createElementVNode("td", _hoisted_8, _toDisplayString(element.registration), 1),
                _createElementVNode("td", _hoisted_9, _toDisplayString(element.last_activity), 1),
                _createElementVNode("td", _hoisted_10, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.DeleteDevice($event, element.uniqid))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: [ 'fas', 'trash' ] })
                  ], 8, _hoisted_11)
                ])
              ], 8, _hoisted_4))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devices, (element) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: element.uniqid,
                id: element.uniqid
              }, [
                _createElementVNode("td", _hoisted_14, _toDisplayString(element.name), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(element.model), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(element.identifier), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(element.registration), 1),
                _createElementVNode("td", _hoisted_18, _toDisplayString(element.last_activity), 1),
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.DeleteDevice($event, element.uniqid))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: [ 'fas', 'trash' ] })
                  ], 8, _hoisted_20)
                ])
              ], 8, _hoisted_13))
            }), 128))
          ]))
    ])
  ]))
}